import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnInit, AfterContentInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { messageService } from 'src/app/message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { PaginationService } from 'src/app/PaginationService';
import { DatePipe } from '@angular/common';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-training-review-period',
  templateUrl: './training-review-period.component.html',
  styleUrls: ['./training-review-period.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TrainingReviewPeriodComponent implements OnInit, AfterContentInit {

  isProcessing = true;
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly elem: ElementRef,
    public message: messageService, public paginationService: PaginationService, private readonly datePipe: DatePipe) {

    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  parentCheckBox: boolean = false;
  childCheckBoxes: boolean = false;
  searchValue: any;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.trainingReviewPeriodList) {
        element.childCheckBoxes = true;
      }
    } else {
      for (const element of this.trainingReviewPeriodList) {
        element.childCheckBoxes = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, listOfDmsGroupsVwDetails: any, idx: any) {
    console.log(e, listOfDmsGroupsVwDetails, idx);
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.trainingReviewPeriodList[this.previousSelectedValue].childCheckBoxes = false;
      }
      listOfDmsGroupsVwDetails.childCheckBoxes = true;
    } else {
      listOfDmsGroupsVwDetails.childCheckBoxes = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.ngOnInit();
  }

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  maxSize = 3;
  collectionSize: number;
  showingRowsText = "Showing rows";
  perPage = 10;
  pager: any = {};
  pagedItems: any[];
  calculateTotalPages: number;
  trainingReviewPeriodList: any = [];
  searchByUserName: any = null;

  ngOnInit() {
    this.isProcessing = true;
    this.appService.getLmsTrainingReviewPeriodVwDetails().subscribe({
      next: (response: any) => {
        this.trainingReviewPeriodList = response;
        this.collectionSize = this.trainingReviewPeriodList.length;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    })
  }

  hyperLinkFlag: boolean;
  ngAfterContentInit() {
    this.hyperLinkFlag = true;
  }

  hyperLinkFunction() {
    if (this.hyperLinkFlag) {
      this.hyperLinkFlag = false;
      let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-header');
      let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-column');
      elements1.forEach((header: any) => {
        header.style.position = 'sticky';
        header.style.left = '80px';
      })

      elements2.forEach((column: any, key: any) => {
        elements2[key].style.position = 'sticky';
        elements2[key].style.background = 'white';
        elements2[key].style.textDecoration = "underline";
        elements2[key].style.color = "blue";
        elements2[key].style.cursor = "pointer";
        elements2[key].style.left = '80px';
      })
    }
  }

  trainingReviewPeriod: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };
  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  isActiveToggle: boolean;
  isActive(isTagged: boolean) {
    this.isActiveToggle = isTagged;

  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Training Review Period";
    this.trainingReviewPeriod.reviewPeriodName = '';
    this.trainingReviewPeriod.reviewPeriodDescription = '';
    this.trainingReviewPeriod.isFixedPeriod = false;
    this.trainingReviewPeriod.fromDate = null;
    this.trainingReviewPeriod.toDate = null;
    this.trainingReviewPeriod.isActive = true;
    this.trainingReviewPeriod.updateReason = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataReviewPeriodId: any;
  openEditPopup(editRowData: any) {

    this.isProcessing = true;
    this.previousData = editRowData;
    console.log(this.previousData);
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Training Review Period";
    this.previousDataReviewPeriodId = editRowData.reviewPeriodId;
    this.appService.getLmsTrainingReviewPeriodVwDetailsByReviewPeriodId(editRowData.reviewPeriodId).subscribe((response: any) => {
      this.trainingReviewPeriod = response;
      this.trainingReviewPeriod.isFixedPeriod = this.trainingReviewPeriod.isFixedPeriod == 'Y';
      this.trainingReviewPeriod.isActive = this.trainingReviewPeriod.isActive == 'Y';
      this.trainingReviewPeriod.fromDate = this.trainingReviewPeriod.fromDate ? new Date(this.trainingReviewPeriod.fromDate.split('T')) : null;
      this.trainingReviewPeriod.toDate = this.trainingReviewPeriod.toDate ? new Date(this.trainingReviewPeriod.toDate.split('T')) : null;
      this.trainingReviewPeriod.updateReason = '';
      this.isProcessing = false;
    })
    this.trainingReviewPeriod.updateReason = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addOrEdit(trainingReview: any) {

    const validations = [
      { condition: !trainingReview.reviewPeriodName, id: 'review-period-name' },
      { condition: !trainingReview.reviewPeriodDescription, id: 'review-period-description' },
      { condition: this.visibleEditButton && !trainingReview.updateReason, id: 'update-validation' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.showSnackBar('Please enter all mandatory fields!', 'E');
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      const data = {

        reviewPeriodName: trainingReview.reviewPeriodName,
        reviewPeriodDescription: trainingReview.reviewPeriodDescription,
        updateReason: trainingReview.updateReason,
        isFixedPeriod: trainingReview.isFixedPeriod ? 'Y' : 'N',
        isActive: trainingReview.isActive ? 'Y' : 'N',
        fromDate: trainingReview.fromDate ? this.datePipe.transform(trainingReview.fromDate, 'yyyy-MM-dd') : null,
        toDate: trainingReview.toDate ? this.datePipe.transform(trainingReview.toDate, 'yyyy-MM-dd') : null,
      }

      if (this.operationFlag == 'ADD') {

        this.appService.createLmsTrainingReviewPeriod(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        let modifiedData = {
          ...data,
          reviewPeriodId: this.previousDataReviewPeriodId
        }

        this.appService.updateLmsTrainingReviewPeriod(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddOrEdit() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReviewPeriodId: any;
  deleteReviewPeriodName: any;
  deleteReviewPeriodDescription: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Review Period";
    this.deleteReviewPeriodId = deleteRowData.reviewPeriodId;
    this.deleteReviewPeriodName = deleteRowData.reviewPeriodName;
    this.deleteReviewPeriodDescription = deleteRowData.reviewPeriodDescription;
    if (this.trainingReviewPeriod.deleteReason != undefined) {
      this.trainingReviewPeriod.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteCall(trainingReview: any) {
    if (trainingReview.deleteReason) {
      this.isProcessing = true;
      const data = {
        reviewPeriodId: this.deleteReviewPeriodId,
        reviewPeriodName: this.deleteReviewPeriodName,
        reviewPeriodDescription: this.deleteReviewPeriodDescription,
        deleteReason: this.trainingReviewPeriod.deleteReason,
      }

      this.appService.deleteLmsTrainingReviewPeriod(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDelete() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.trainingReviewPeriodList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.trainingReviewPeriodList.length, page, this.perPage, targetPage);
    this.pagedItems = this.trainingReviewPeriodList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    if (this.trainingReviewPeriodList.length > 0) {
      this.pager = this.paginationService.getPager(this.trainingReviewPeriodList.length, page, this.perPage, targetPage);
      this.pagedItems = this.trainingReviewPeriodList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, reviewPeriod: any) {
    this.message.tableOrView_Name = "TMS_TRAINING_REVIEW_PERIOD_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,REVIEW_PERIOD_NAME,REVIEW_PERIOD_DESCRIPTION,IS_ACTIVE,IS_FIXED_PERIOD,FROM_DATE,TO_DATE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Review Period Name,Review Period Description,Is Active,Is Fixed Period,From Date,To Date,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? '' : " AND REVIEW_PERIOD_ID=" + reviewPeriod.reviewPeriodId;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Review Period Name,Review Period Description,Is Active,Is Fixed Period,From Date,To Date,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? '' : " WHERE REVIEW_PERIOD_ID=" + reviewPeriod.reviewPeriodId;
    this.message.report_And_Popup_Name = "Training Review Period Audit Trail";
    this.message.manualEntryDataFields = "FROM_DATE,TO_DATE"
    this.staticAuditTrailComponent.triggerTrail(reviewPeriod);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_TRAINING_REVIEW_PERIOD_VW";
    this.excelPdf.columnList_DB = "REVIEW_PERIOD_NAME,REVIEW_PERIOD_DESCRIPTION,IS_ACTIVE,IS_FIXED_PERIOD,FROM_DATE,TO_DATE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
    this.excelPdf.columnList_Report = "Review Period Name,Review Period Description,Is Active,Is Fixed Period,From Date,To Date,Created On,Created By,Updated On,Updated By";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Training Review Period Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdf.manualEntryDataFields = "FROM_DATE,TO_DATE"
    this.excelPdfComponent.openReportPopup(reportType);

  }

  columnSearch(column: string, event: Event, dataType: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.trainingReviewPeriodList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingReviewPeriodList.filter((item: any) => {
        const columnValue = item[column];
        if (dataType === 'date') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  $generateToDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: new Date(this.trainingReviewPeriod.fromDate),
    };
  }

  onFromDateChange() {
    if (this.trainingReviewPeriod.toDate && (this.trainingReviewPeriod.fromDate > this.trainingReviewPeriod.toDate)) this.trainingReviewPeriod.toDate = null;
  }

}
